import { memo, useEffect } from "react";
import { store } from "shared/store/store";
import { useSnapshot } from "valtio";

interface LoadingLayoutProps {
  isStandardProduct: boolean;
}
const LoadingLayout: React.FC<LoadingLayoutProps> = memo(
  ({ isStandardProduct }) => {
    const snap = useSnapshot(store);

    useEffect(() => {
      const loadingTimeout = setTimeout(
        () => {
          store.active = false;
        },
        isStandardProduct ? 1250 : 1250,
      );

      // Cleanup the timeout
      return () => clearTimeout(loadingTimeout);
    }, []);

    return (
      // ORIGINAL
      // <div
      //   className={`gg-transition-all gg-ease-in-out gg-duration-1000 gg-grid gg-justify-items-center gg-pt-72 sm:gg-pt-0 sm:gg-place-items-center gg-bg-[#EEECEC] gg-left-0 gg-top-0 gg-absolute gg-w-full gg-h-full gg-z-30  ${
      //     snap.active === true ? "gg-opacity-100" : "gg-opacity-0 gg-invisible"
      //   }`}
      // >
      // END OF ORIGINAL

      // NEW
      <div
        className={`gg-duration-400 gg-fixed gg-left-0 gg-top-0 gg-z-30 gg-grid gg-h-full gg-w-full gg-justify-items-center gg-bg-[#EEECEC] gg-pt-72 gg-transition-all gg-ease-in-out sm:gg-absolute sm:gg-place-items-center sm:gg-pt-0 ${
          snap.active === true ? "gg-opacity-100" : "gg-invisible gg-opacity-0"
        }`}
      >
        {/* END OF NEW */}

        {/*<div className="sm:gg-pb-96 lg:gg-pb-72 xl:gg-pb-0 ">*/}
        {/*  <LoadingLogo />*/}
        {/*</div>*/}

        {/* CUSTOM LOGO */}
        <div className="sm:gg-pb-40 xl:gg-pb-0">
          <div
            className="gg-motion-reduce:animate-[spin_1.5s_linear_infinite] gg-inline-block gg-h-40 gg-w-40 gg-animate-spin gg-rounded-full gg-border-4 gg-border-solid gg-border-current gg-border-r-transparent gg-align-[-0.125em]"
            role="status"
          ></div>
        </div>
        {/* CUSTOM LOGO */}
      </div>
    );
  },
);

export default LoadingLayout;
